import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    enabled: {
      inputType: 'toggle',
      title: 'Enabled',
    },
    content: {
      inputType: 'ckeditor',
      title: 'Email Template',
      height: 700,
    },
  }
}
